import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/css'
import { Button } from '@contrast-security-inc/design-system-buttons'

export function SaveButton({ disabled, onClick }) {
  return (
    <FormattedMessage id="action_save">
      {(text) => {
        return (
          <Button
            isDisabled={disabled}
            className={css`
              margin-left: 8px;
            `}
            onClick={onClick}
          >
            {text}
          </Button>
        )
      }}
    </FormattedMessage>
  )
}
